import { env } from '~/app/environment/env'

export type AppsFlyerEnvironment = 'prod' | 'dev'

export function getAppsFlyerEnvironment(): AppsFlyerEnvironment {
  return env.UVO_FIREBASE_CONFIG === 'production' ? 'prod' : 'dev'
}

type AppsFlyerInAppEventValue = Record<string, unknown>

/** Sends a PBA in-app event with a global `environment` marker on every payload. */
export function logAppsFlyerInAppEvent(
  eventName: string,
  eventValue: AppsFlyerInAppEventValue
): void {
  if (typeof window === 'undefined') return
  window.AF?.('pba', 'event', {
    eventType: 'EVENT',
    eventName,
    eventValue: {
      ...eventValue,
      environment: getAppsFlyerEnvironment(),
    },
  })
}
